import { SignInState } from './SignInState';
import { AsyncActionStatus, IAsyncAction } from 'State/AsyncAction';
import { IRewardData } from 'Utility/RewardHelper';

export interface IPlatformState {
    IAPSupport: boolean;
    adsInterstitial: boolean;
    adsRewarded: boolean;
    switchGame: boolean;
    subscribeBot: boolean;
    signInState: SignInState;
    facebookSignInReward: IAsyncAction<IRewardData[]>;
}

export const initialPlatformState: IPlatformState = {
    IAPSupport: false,
    adsInterstitial: false,
    adsRewarded: false,
    switchGame: false,
    subscribeBot: false,
    signInState: SignInState.SignedOut,
    facebookSignInReward: {
        status: AsyncActionStatus.EMPTY,
        result: []
    }
};
